import React from 'react';
import './Mission.css';

const Mission = () => {
  return (
    <section id="mission" className="mission">
      <div className="container">
        <div className="mission-content">
          <div className="mission-header">
            <h2 className="section-title">Mission</h2>
          </div>
          <p className="mission-text">
            To become the one agency you trust, rely on, and keep coming back to — 
            your creative partner for every brand challenge and every big leap.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Mission;

